const LOCAL_STORAGE_KEYS = {
	CAMERA_DEVICE_ID: 'CAMERA_DEVICE_ID'
	, MICROPHONE_DEVICE_ID: 'MICROPHONE_DEVICE_ID'
	, SPEAKER_DEVICE_ID: 'SPEAKER_DEVICE_ID'
};

export default LOCAL_STORAGE_KEYS;